import { Component } from 'react';
import { checkFontsLoaded, fontsLoaded as areFontsLoaded } from 'foundations-components/utils/fonts';
import { FONTS_TO_LOAD } from './constants';
class WaitUntilFontsAndIconsAreLoaded extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      fontsLoaded: areFontsLoaded()
    };
  }
  componentDidMount() {
    const {
      timeoutOverride,
      checkFontsLoadedOverride,
      fontsToLoad
    } = this.props;
    this._isMounted = true;
    if (!areFontsLoaded()) {
      checkFontsLoadedOverride(fontsToLoad).then(() => {
        if (this._isMounted) {
          this.setState({
            fontsLoaded: true
          });
        }
      }).catch(() => {
        this.setState({
          fontsLoaded: false
        });
      });
    }

    // Fallback incase the fonts don't load, if after 5 seconds the font promise doesn't resolve
    // just mount the downstream components (dnd area toolbars) so atleast _something_ displays / functions
    // for users, even if it doesn't look quite right due to missing fonts. Only do this if this component is still mounted
    // (it will get unmounted once measurements are actually taken)
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({
          fontsLoaded: true
        });
      }
    }, timeoutOverride);
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const {
      children
    } = this.props;
    const {
      fontsLoaded
    } = this.state;
    if (!fontsLoaded) {
      return null;
    }
    return children;
  }
}
WaitUntilFontsAndIconsAreLoaded.defaultProps = {
  checkFontsLoadedOverride: checkFontsLoaded,
  fontsToLoad: FONTS_TO_LOAD,
  timeoutOverride: 5000
};
export default WaitUntilFontsAndIconsAreLoaded;